"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _collapsingNav = require("@dbi-tools/ui-kit/lib/ecommerce/components/collapsing-nav/collapsing-nav");

var _useMedia = require("../../hooks/use-media");

var _const = require("../../const");

var _const2 = require("./const");

var _linksGrid = require("./links-grid.styled");

var _headerTitles = require("../header-titles");

var _themeOptions = require("../../helpers/theme-options");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNavItems = function getNavItems(links) {
  var reducedLinks = links.reduce(function (reduced, _ref) {
    var linkLocation = _ref.linkLocation,
        linkText = _ref.linkText;
    reduced.push({
      name: linkText,
      href: linkLocation
    });
    return reduced;
  }, []);
  return [{
    headline: _const2.DEFAULT_MENU_NAME,
    links: reducedLinks
  }];
};

var LinksGrid = function LinksGrid(props) {
  var headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      _props$columns = props.columns,
      columns = _props$columns === void 0 ? '3' : _props$columns,
      _props$links = props.links,
      links = _props$links === void 0 ? [] : _props$links,
      _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _const2.LinksGridTheme.WHITE : _props$theme,
      _props$buttonLinkColo = props.buttonLinkColor,
      buttonLinkColor = _props$buttonLinkColo === void 0 ? _const2.LinksGridButtonColor.CLARET : _props$buttonLinkColo,
      removeTopPadding = props.removeTopPadding,
      removeBottomPadding = props.removeBottomPadding;

  if (!headline1 && !headline2 && !description && !links.length) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure LINKS GRID component");
  }

  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var paddingSize = isMobile ? _const.MOBILE_PADDING_SIZE : _const.DEFAULT_PADDING_SIZE;
  var bottomPadding = removeBottomPadding ? 0 : paddingSize;
  var topPadding = removeTopPadding ? 0 : paddingSize;
  var containerPadding = [topPadding, 0, bottomPadding];
  var _themeStrategy = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy.headline1Color,
      headline2Color = _themeStrategy.headline2Color;
  var _linksGridButtonsProp = _const2.linksGridButtonsProps[buttonLinkColor],
      variant = _linksGridButtonsProp.variant,
      color = _linksGridButtonsProp.color,
      accentColor = _linksGridButtonsProp.accentColor;
  var theme = {
    $theme: currentTheme
  };
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_linksGrid.StyledBox, {
    p: containerPadding,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_LINKS_GRID
  }, /*#__PURE__*/_react.default.createElement(_container.Container, null, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    noGutters: true,
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color
  }), isMobile && !!links.length ? /*#__PURE__*/_react.default.createElement(_linksGrid.CollapsingNavWrapStyled, {
    navColor: color,
    navStyle: variant,
    accentColor: accentColor
  }, /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNav, {
    isSimple: true,
    items: getNavItems(links)
  })) : /*#__PURE__*/_react.default.createElement(_linksGrid.LinksGridStyled, {
    columns: parseInt(columns)
  }, !!links.length && links.map(function (_ref2, index) {
    var linkText = _ref2.linkText,
        linkLocation = _ref2.linkLocation;
    return /*#__PURE__*/_react.default.createElement(_linksGrid.LinksGridItemStyled, {
      key: "".concat(linkText, "-").concat(index)
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      variant: variant,
      color: color,
      fullWidth: true,
      as: "a",
      href: linkLocation
    }, linkText));
  })))));
};

var _default = LinksGrid;
exports.default = _default;